<template>
  <div>
    <b-form-input
      type="text"
      id='NameInputBox'
      :value="value"
      @input="$emit('input', $event)"
      autocomplete="off"
      placeholder="RBP's Name or Ensmbel ID"
    >
    </b-form-input>
    <b-popover
      target="NameInputBox"
      triggers="focus"
      placement="down"
      style="max-width: 700px"
      class="w-75"
    >
      <b-list-group style="height: auto;overflow-y: auto;max-height: 300px">
        <b-list-group-item v-if="suggest===null">type at least 2 characters to start search...</b-list-group-item>
        <b-list-group-item class="smallFont" href="#" v-for="(rbp, index) in suggest" :key="rbp+index"
                           @click="selectOne(rbp)" v-else>
          {{ rbp['ensemblID'] }} ({{ rbp['symbol'] }})
        </b-list-group-item>
      </b-list-group>
    </b-popover>
  </div>
</template>

<script>
export default {
  name: 'searchInput',
  props: ['value'],
  data: () => ({
    userInput: null,
    suggest: null
  }),
  methods: {
    selectOne: function (sel) {
      this.$emit('input', sel.symbol)
    },
    searchRBPs: function () {
      this.axios({
        url: 'search.php',
        method: 'post',
        data: {
          'rbp': '%' + this.value.split('').join('%') + '%',
          'type': [ 'rbp' ]
          // method: 'search'
        }
      }).then(res => {
        this.suggest = res.data[ 'rbps' ]
      })
    }
  },
  watch: {
    value: function (newInput, oldInput) {
      if (newInput.length >= 2) {
        this.searchRBPs()
      }
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SearchInput.vue